/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { DataIndexCampaign } from 'cio/utils/data-index';
import { pluralize } from 'ember-inflector';

interface DataIndexItemCampaignsItemArgs {
  dataIndexCampaign: DataIndexCampaign;
}

export default class DataIndexItemCampaignsItem extends Component<DataIndexItemCampaignsItemArgs> {
  @tracked isExpanded = false;

  get usageItems() {
    let campaignUsage = this.args.dataIndexCampaign.usage ?? [];

    let usageCounts = campaignUsage.reduce((counts: Record<string, number>, usage) => {
      let count = counts[usage] ?? 0;
      counts[usage] = count + 1;
      return counts;
    }, {});

    return Object.keys(usageCounts).map((key) => {
      let count = usageCounts[key];
      return count === 1 ? key : `${count} ${pluralize(key)}`;
    });
  }
}
